export default __webpack_public_path__ + "static/MediaContentSix-b84d9bcf2e91143e34a846a09e06bae4.webp";